import React, { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageBanner from "../components/PageBanner";
import QuoteBand from "../components/QuoteBand";
import Reveal from "../components/Reveal";
import { news } from "../mock";

export default function NewsDetail() {
  const { slug } = useParams();
  const item = news.find((n) => n.slug === slug);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!item) return <Navigate to="/haberler" replace />;
  const others = news.filter((n) => n.slug !== slug);

  return (
    <div className="bg-white" data-testid="news-detail-page">
      <PageBanner
        title={item.title}
        breadcrumbs={[{ label: "Bizden Haberler", to: "/haberler" }, { label: item.title }]}
        image="/images/slider/slider2.jpg"
      />
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 lg:gap-20">
          <article className="lg:col-span-8">
            <Reveal>
              <div className="frame">
                <img src={item.image} alt={item.title} className="w-full h-[380px] lg:h-[460px] object-cover" />
              </div>
              <div className="mt-10 flex items-center gap-3">
                <span className="w-10 h-px bg-brand-accent/45" />
                <span className="eyebrow text-brand-accent">{item.date}</span>
              </div>
              <h2 className="font-display text-2xl md:text-[2.1rem] font-light text-brand-ink mt-5 tracking-[-0.03em] leading-[1.2]">
                {item.title}
              </h2>
              <div className="mt-8 space-y-5 text-[14.5px] text-brand-muted leading-[1.85] font-light max-w-2xl">
                {item.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
              <Link
                to="/haberler"
                className="mt-12 inline-flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.18em] border border-brand-line hover:border-brand-ink text-brand-ink px-6 py-3.5 rounded-full transition-colors duration-300"
              >
                <ArrowLeft className="w-3.5 h-3.5" /> Tüm Haberler
              </Link>
            </Reveal>
          </article>
          <aside className="lg:col-span-4">
            <div className="border border-brand-line p-7">
              <h3 className="eyebrow text-brand-muted mb-6">Diğer Haberler</h3>
              <ul className="space-y-5">
                {others.map((n) => (
                  <li key={n.slug}>
                    <Link to={`/haber/${n.slug}`} className="group flex gap-4 items-center">
                      <img src={n.image} alt={n.title} className="w-16 h-16 object-cover flex-shrink-0" />
                      <div>
                        <div className="font-mono text-[9.5px] uppercase tracking-[0.18em] text-brand-accent">{n.date}</div>
                        <div className="mt-1.5 text-[13px] text-brand-ink group-hover:text-brand-accent transition-colors duration-300 line-clamp-2">
                          {n.title}
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>
      <QuoteBand />
    </div>
  );
}
